import { render, staticRenderFns } from "./UserEditCard.vue?vue&type=template&id=4e3e3230&"
import script from "./UserEditCard.vue?vue&type=script&lang=js&"
export * from "./UserEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports